import Fresco61 from "./fresco6.webp";

const Fresco6 = [Fresco61];

export default Fresco6;
